import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import httpRequest from 'src/helpers/httpRequest';
import iconCategory from "src/assets/images/admin-dashboard/category-icon.png";
import iconService from "src/assets/images/admin-dashboard/service-icon.png";
import iconAppointment from "src/assets/images/admin-dashboard/appointment-icon.png";
import iconRevenue from "src/assets/images/admin-dashboard/revenue-icon.png";
import { CircularProgress } from '@mui/material';
import { CURRENCY } from 'src/lib/constans';

type IStatsKeys = "totalCategories" | "totalService" | "totalAppointment" | "totalRevenue";

const HomecareStates: React.FC = () => {
    const [statsLoader, setStatsLoader] = useState<boolean>(false);
    const [statsData, setStatsData] = useState<{ label: string; key: IStatsKeys; count: number; images: string }[]>([
        { label: "Total Categories", key: "totalCategories", count: 0, images: iconCategory },
        { label: "Total Services", key: "totalService", count: 0, images: iconService },
        { label: "Total Appointment", key: "totalAppointment", count: 0, images: iconAppointment },
        { label: "Total Revenue", key: "totalRevenue", count: 0, images: iconRevenue },
    ]);
    const fetchStats = async () => {
        setStatsLoader(true);
        const { res, err } = await httpRequest<{ data: { [keys in IStatsKeys]: number } }>({
            path: "/home-care-services/get-dashboard-data",
        });
        if (res) {
            const updatedStatsData = statsData.map((item) => {
                return {
                    ...item,
                    count: res.data[item.key],
                };
            });
            setStatsData(updatedStatsData);
        } else {
            toast(err, { type: "error" });
        }
        setStatsLoader(false);
    };

    useEffect(() => {
        fetchStats();
    }, []);
    return (
        <div className='parent-box'>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3">
                {statsData.map(item => (
                    <div key={item.key} className="dashboard-sm-box">
                        <div className="dashboard-inner-box w-[80%] text-center">
                            <img className='admin-dashboard-img' src={item?.images} alt="biomarker-icon" />
                            <p className="font-Poppins-Medium whitespace-nowrap font-size-20px">
                                {item?.label || ""}
                            </p>
                            {statsLoader
                                ?
                                <CircularProgress size={20} className="theme-color-green" />
                                :
                                <p className="font-Poppins-SemiBold font-size-26px theme-color-green">
                                    {`${item.key === "totalRevenue" ? CURRENCY : ""}${item.count || "-"}`}
                                </p>
                            }
                        </div>
                    </div>
                ))
                }
            </div>
        </div>
    );
};

export default HomecareStates;